import { useMemo } from 'react';

import { SourceDomain } from '@pflegia/types/api/source-domain/source-domain';
import { useFlavorFromRoute } from '@pflegia/ui/hooks/use-flavor-from-route';

import { LOGO_PATH, LOGO_EXTENSION } from '@shared/constants/logo';

import { getBaseUrlByHostName } from '@utils/domain';

const getLogo = (domain: SourceDomain) => {
  let fileName: string;
  switch (domain) {
    case SourceDomain.PraxiaDe:
      fileName = 'praxia';
      break;

    case SourceDomain.PflegiaDe:
    case SourceDomain.PflegiaAt:
    default:
      fileName = 'pflegia';
      break;
  }
  return `${LOGO_PATH}/${fileName}.${LOGO_EXTENSION}`;
};

export const useLogoUrl = () => {
  const { sourceDomain } = useFlavorFromRoute();
  return useMemo(() => new URL(getLogo(sourceDomain), getBaseUrlByHostName(sourceDomain)).toString(), [sourceDomain]);
};
